var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcContractServiceMainMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 96,
    viewBox: "0 0 100 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2031_770)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2031_770)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.1035,
    width: 60.8963,
    height: 81.8631,
    rx: 3.03883,
    fill: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 42.7114,
    y: 36.2734,
    width: 49.5712,
    height: 2.51182,
    rx: 1.25591,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.7114,
    y: 45.623,
    width: 49.5712,
    height: 2.51182,
    rx: 1.25591,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.7114,
    y: 54.9717,
    width: 49.5712,
    height: 2.51182,
    rx: 1.25591,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.7114,
    y: 64.3213,
    width: 35.6221,
    height: 2.51182,
    rx: 1.25591,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0667 19.1106V27.8873H56.9094V19.1106H58.0667ZM56.2342 19.3035V27.5015H55.0672V24.6081H53.8231V23.6147H55.0672V22.4188H53.987C53.5771 23.8655 52.6898 25.0903 51.0454 26.0645L50.322 25.1964C52.1015 24.1452 52.8827 22.8672 53.0515 21.1457H50.8332V20.1523H54.2764C54.2764 20.5911 54.2474 21.0155 54.1992 21.4254H55.0672V19.3035H56.2342ZM67.0942 20.268V21.2614H65.9561V22.1584H67.0942V23.1807H65.9561V24.2898H64.7216V19.1106H65.9561V20.268H67.0942ZM65.9561 24.637V27.8873H64.7216V25.6305H60.0439V24.637H65.9561ZM61.4617 19.5929C62.8216 19.5832 63.8536 20.4898 63.8536 21.7243C63.8536 22.9878 62.8216 23.8751 61.4617 23.8751C60.0921 23.8751 59.0505 22.9878 59.0505 21.7243C59.0505 20.4898 60.0921 19.5832 61.4617 19.5929ZM61.4617 20.6441C60.7672 20.6441 60.2561 21.0396 60.2657 21.7243C60.2561 22.4284 60.7672 22.8335 61.4617 22.8335C62.1368 22.8335 62.648 22.4284 62.6576 21.7243C62.648 21.0396 62.1368 20.6441 61.4617 20.6441ZM70.846 21.0974C70.846 22.7467 71.5115 24.3477 72.9775 24.9843L72.2252 25.968C71.2511 25.4906 70.6 24.6178 70.2384 23.5375C69.8526 24.6853 69.1774 25.6256 68.1744 26.1223L67.4028 25.1193C68.9074 24.4442 69.5922 22.7467 69.6018 21.0974V19.7858H70.846V21.0974ZM74.9353 19.1106V27.9066H73.7201V22.8624H71.9937V21.869H73.7201V19.1106H74.9353Z",
    fill: "#374969"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2031_770)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 33,
    cy: 49,
    rx: 20,
    ry: 19,
    fill: "#BDE9FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2031_770)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0913 66.0996C48.0824 62.7753 52.1372 56.3854 52.1372 49.0483C52.1372 42.2704 48.6768 36.3007 43.4263 32.8096H27.7788V66.0996H42.0913Z",
    fill: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_2031_770)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1371 49.0483C48.1371 57.6015 41.2034 64.5352 32.6503 64.5352C24.0971 64.5352 17.1635 57.6015 17.1635 49.0483C17.1635 40.4952 24.0971 33.5615 32.6503 33.5615C41.2034 33.5615 48.1371 40.4952 48.1371 49.0483ZM52.1371 49.0483C52.1371 59.8106 43.4125 68.5352 32.6503 68.5352C30.349 68.5352 28.1409 68.1363 26.0914 67.4038L10.8493 87.3121L4.49723 82.4489L19.2425 63.1894C15.4984 59.6383 13.1635 54.616 13.1635 49.0483C13.1635 38.2861 21.888 29.5615 32.6503 29.5615C43.4125 29.5615 52.1371 38.2861 52.1371 49.0483Z",
    fill: "#B9B9B9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2031_770",
    x: 2,
    y: 0,
    width: 93,
    height: 92.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_770"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_770",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2031_770",
    x: 32.1035,
    y: 0,
    width: 66.9741,
    height: 87.9409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.03883,
    dy: 3.03883
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.51941
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_770"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_770",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2031_770",
    x: 9,
    y: 30,
    width: 48,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_770"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_770",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2031_770",
    x: 23.7788,
    y: 32.8096,
    width: 32.3584,
    height: 41.29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_770"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_770",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_2031_770",
    x: 0.49707,
    y: 29.5615,
    width: 55.6401,
    height: 65.751,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_770"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_770",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContractServiceMainMobile);
export default __webpack_public_path__ + "static/media/IcContractServiceMainMobile.3e7af880fee8ca26f8e0dd9fbd8c15e9.svg";
export { ForwardRef as ReactComponent };